import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { PriceProvider } from './components/PriceContext';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    document.title = 'Método de Carpintería Plegable | +200 Planos con Medidas Exactas';
    // Preconnects now handled synchronously in index.tsx before render
    // Only load non-critical resources here
    // Load Google Fonts non-blocking (after page paint)
    const loadFonts = () => {
      if (!document.querySelector('link[href*="fonts.googleapis.com/css2"]')) {
        const fontLink = document.createElement('link');
        fontLink.rel = 'stylesheet';
        // Only weight 700 — eliminates the 900 variant download
        fontLink.href = 'https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@700&display=swap';
        document.head.appendChild(fontLink);
      }
    };
    if (document.readyState === 'complete') {
      loadFonts();
    } else {
      window.addEventListener('load', loadFonts, {
        once: true
      });
    }
    // Meta Pixel — deferred until first interaction or 3.5s
    let pixelLoaded = false;
    const loadPixel = () => {
      if (pixelLoaded) return;
      pixelLoaded = true;
      (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', '4238008003115204');
      window.fbq('track', 'PageView');
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=4238008003115204&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.head.appendChild(noscript);
    };
    const interactionEvents = ['mousedown', 'touchstart', 'keydown', 'scroll'];
    interactionEvents.forEach(evt => window.addEventListener(evt, loadPixel, {
      once: true,
      passive: true
    }));
    const pixelTimer = setTimeout(loadPixel, 3500);
    return () => {
      clearTimeout(pixelTimer);
      interactionEvents.forEach(evt => window.removeEventListener(evt, loadPixel));
    };
  }, []);
  return <PriceProvider data-id="element-0">
      <LandingPage data-id="element-1" />
    </PriceProvider>;
}